// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DeviceOtherSvg from '@rsuite/icon-font/lib/device/DeviceOther';
var DeviceOther = createSvgIcon({
  as: DeviceOtherSvg,
  ariaLabel: 'device other',
  category: 'device',
  displayName: 'DeviceOther'
});
export default DeviceOther;